import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource, MatSnackBar } from '@angular/material';
import { CreateEjeComponent } from '../create-eje/create-eje.component';
import { Handle } from 'src/app/handle';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { Md5 } from 'ts-md5/dist/md5';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-create-agente',
  templateUrl: './create-agente.component.html',
  styleUrls: ['./create-agente.component.scss']
})
export class CreateAgenteComponent implements OnInit {
  //displayedColumns = ['CAMPANA', 'REGISTROS', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'BORRAR'];
  displayedColumns = ['CAMPANA', 'CONTACTO', 'EFECTIVIDAD', 'CONVERSION', 'TMO', 'LLAMADAS', 'LLAMADASCEP', 'BORRAR'];
  displayedColumnsLog = ['ACCION', 'COMENTARIO', 'FECHA'];
  displayedColumnsLogRol = ['ROLN', 'ROLA', 'COMENTARIO', 'FECHA'];
  dataSource = new MatTableDataSource<any>([]);
  dataSourceLog = new MatTableDataSource<any>([]);
  dataSourceLogRol = new MatTableDataSource<any>([]);
  FILTER; resultsLength = 0;
  roles = [];
  // Roles "Tipo Permisos" (rol_alterno para agentes idrol_permiso)
  rolesAgente = [];
  areas = [];
  contratasagente = [];
  tipos_tecnico = [{ id: 1, nombre: 'Técnico Recolector Contrata' }, { id: 2, nombre: 'Técnico Recolector Interno' }];
  provincias = [];
  provinciasxagente = [];
  distritos = [];
  corregimientos = [];
  table = [];
  tablelog = [];
  tablelogrol = [];
  campanas = [];
  maxDate = new Date();

  constructor(
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CreateEjeComponent>, public Handle: Handle,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  operacion = 'createagente';
  idagente = '';
  idpais;

  passaux = '';

  // Multiusos: distribuidores del tecnico
  estadoReparaciones = false;
  estadoInstalaciones = false;
  distribuidorLogueado: number = 0;

  async ngOnInit() {
    this.idpais = this.data.agente.idpais;
    this.getCampanas();
    this.getRoles();
    this.getRolesAgente();
    this.getAreasAgente();
    this.getContratasAgente();
    this.getHistorico();
    this.getProvincias();

    // console.log(this.data.agente);
    // this.grupoVal.controls.ROL.setValue(17);
    if (this.data.operacion == 'Editar') {
      this.operacion = 'editagente';
      this.idagente = this.data.agente.idagente;
      this.getCorregimientos1();
      this.getCorregimientos2((this.data.agente.idrol == 20));
      await this.getProvinciasxAgente(this.idagente);
      this.grupoVal.controls.NOMBRE.setValue(this.data.agente.nombre);
      this.grupoVal.controls.APELLIDO.setValue(this.data.agente.apellido);
      this.grupoVal.controls.ROL.setValue(this.data.agente.idrol);
      this.grupoVal.controls.AREA.setValue(this.data.agente.idareaagente);

      this.grupoVal.controls.TIPO_TECNICO.setValue(this.data.agente.tipo_tecnico);
      this.grupoVal.controls.NOMBRE_CONTRATA.setValue(this.data.agente.contrata_id);
      this.grupoVal.controls.CAPMAXAM.setValue(this.data.agente.capacidad_am);
      this.grupoVal.controls.CAPMAXPM.setValue(this.data.agente.capacidad_pm);

      this.opcionRolSeleccionada({ value: this.data.agente.idrol });

      this.grupoVal.controls.FECHA_NACIMIENTO.setValue(this.data.agente.fechanacimiento);
      this.grupoVal.controls.GENERO.setValue(this.data.agente.genero);
      this.grupoVal.controls.CORREO.setValue(this.data.agente.correo);
      this.grupoVal.controls.CORREO2.setValue(this.data.agente.correo2);
      this.grupoVal.controls.TELEFONO.setValue(this.data.agente.telefono);
      this.grupoVal.controls.PROFESION.setValue(this.data.agente.profesion);
      this.grupoVal.controls.PASS.setValue(this.data.agente.pass);
      this.grupoVal.controls.CUENTA.setValue(this.data.agente.cuenta);
      this.grupoVal.controls.TOKEN.setValue(this.data.agente.token);
      this.grupoVal.controls.URL.setValue(this.data.agente.url);
      this.grupoVal.controls.CONFIGCANAL.setValue(this.data.agente.configcanal);
      this.grupoVal.controls.PROVINCIA.setValue(this.provinciasxagente);
      this.passaux = this.data.agente.pass;

      // Cargar campos supervisor/jefe y piloto para tecnicos
      if (this.data.agente.idrol == 20) {
        this.grupoVal.controls.SUPERVISOR.setValue(this.data.agente.supervisor || '');
        this.grupoVal.controls.TEL_SUPERVISOR.setValue(this.data.agente.tel_supervisor || '');
        this.grupoVal.controls.JEFE.setValue(this.data.agente.jefe || '');
        this.grupoVal.controls.TEL_JEFE.setValue(this.data.agente.tel_jefe || '');
        this.grupoVal.controls.PILOTO.setValue(this.data.agente.piloto == 1);
      }

      // Multiusos: cargar estados de distribuidores
      this.distribuidorLogueado = this.localSave.get('usuarioPGV').IDU;
      if (this.data.agente.idrol == 20) {
        this.estadoReparaciones = this.data.agente.estado_reparaciones == 1;
        this.estadoInstalaciones = this.data.agente.estado_instalaciones == 1;
      }

      this.gateway.save('gethorariosagente', { ID: this.idagente }).then((result: any) => {
        this.listaHorarios = result.rows || [];
        this.dataSourceHorario.data = this.listaHorarios;
      }
      ).catch(function (e) { });

      // Cargar idrol_permiso (Tipo Permisos) para mostrar el valor actual
      this.gateway.get('getidrolpermiso', { idagente: this.idagente }).then((result: any) => {
        var idrolPerm = result && result.data ? result.data.idrol_permiso : null;
        this.grupoVal.controls.TIPOPERMISOS.setValue(idrolPerm || null);
      }).catch(() => { /* ignore */ });

      this.onInputChange();
    } else {
      this.getCorregimientos1();
      this.getCorregimientos2();
    }
  }

  /**
   * -------------------------------------------------------
   * HORARIOS DEL TECNICO
   * -------------------------------------------------------
   */

  diasSemana = [
    'Lunes', 'Martes', 'Miércoles', 'Jueves',
    'Viernes', 'Sabado', 'Domingo'
  ];
  displayedHorario = ['HORA_INICIAL', 'HORA_FINAL', 'DIA', 'ACCION'];
  listaHorarios = [];
  dataSourceHorario = new MatTableDataSource<any>([]);

  grupoHorario = new FormGroup({
    HORA_INICIAL: new FormControl('', Validators.required),
    HORA_FINAL: new FormControl('', Validators.required),
    DIA: new FormControl([], Validators.required)
  }, this.validarHoras);

  validarHoras(formGroup: FormGroup) {
    const start = formGroup.get('HORA_INICIAL').value;
    const end = formGroup.get('HORA_FINAL').value;

    if (!start || !end) return null;

    // Convertir a minutos para comparar
    const startMin = parseInt(start.replace(':', ''), 10);
    const endMin = parseInt(end.replace(':', ''), 10);

    return startMin < endMin ? null : { horaInvalida: true };
  }

  agregarHorario() {
    if (this.grupoHorario.invalid) return;

    const horaInicial = this.grupoHorario.controls.HORA_INICIAL.value;
    const horaFinal = this.grupoHorario.controls.HORA_FINAL.value;
    const diasSeleccionados: string[] = this.grupoHorario.controls.DIA.value;

    let duplicados = [];

    diasSeleccionados.forEach(dia => {
      const existe = this.listaHorarios.some(h => h.DIA === dia);
      if (existe) {
        duplicados.push(dia);
        return;
      }

      this.listaHorarios.push({
        HORA_INICIAL: horaInicial,
        HORA_FINAL: horaFinal,
        DIA: dia
      });
    });

    if (duplicados.length > 0) {
      this.snackbar.open(
        `Los siguientes días ya tienen horario asignado: ${duplicados.join(', ')}`,
        'Cerrar',
        { duration: 3000 }
      );
    }

    this.dataSourceHorario.data = this.listaHorarios;

    // Limpiar el formulario de horarios
    this.grupoHorario.reset();
  }

  eliminarHorario(index: number) {
    this.listaHorarios.splice(index, 1);
    this.dataSourceHorario.data = this.listaHorarios;
  }

  /**
   * -------------------------------------------------------
   * MULTIUSOS: Toggle de distribuidor para tecnicos
   * -------------------------------------------------------
   */
  toggleDistribuidor(iddistribuidor: number, checked: boolean) {
    const estado = checked ? 1 : 0;
    this.gateway.save('toggleDistribuidorTecnico', {
      IDAGENTE: this.idagente,
      IDDISTRIBUIDOR: iddistribuidor,
      ESTADO: estado
    }).then((result: any) => {
      if (iddistribuidor === 44) this.estadoReparaciones = checked;
      if (iddistribuidor === 41) this.estadoInstalaciones = checked;
      this.snackbar.open('Estado de distribuidor actualizado.', 'Cerrar', { duration: 3000 });
    }).catch((e) => {
      this.snackbar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
    });
  }

  /**
   * -------------------------------------------------------
   * CORREGIMIENTOS
   * -------------------------------------------------------
   */
  zonasprincipales = [];
  zonasalternas = [];
  canales = [];
  unidades = [];
  displayedColumns1: string[] = ['zonaprincipal'];
  displayedColumns2: string[] = ['zonaalterna'];
  dataSource1 = this.zonasprincipales;
  dataSource2 = this.zonasalternas;
  auxresult: any = null;
  auxresult1: any = null;
  auxresult2: any = null;
  auxresult3: any = null;
  isLoadingResults = true;
  local_data: any;

  getCorregimientos1() {
    this.gateway.get('getcorregimientos', { esprincipal: 1, IDTECNICO: this.idagente }).then((result) => {
      let aux: any = result;
      this.auxresult = aux.rows;
      this.zonasprincipales = this.auxresult;
      this.dataSource1 = this.zonasprincipales;
      this.handleInputChange1();
    }
    ).catch((e) => {
    });
  }

  getCorregimientos2(esperar = false) {
    if (esperar) this.spinner.show();
    this.gateway.get('getcorregimientos', { esprincipal: 0, IDTECNICO: this.idagente }).then((result) => {
      let aux: any = result;
      this.auxresult = aux.rows;
      this.zonasalternas = this.auxresult;
      this.dataSource2 = this.zonasalternas;
      this.handleInputChange2();
      if (esperar) this.spinner.hide();
    }
    ).catch((e) => {
    });
  }

  inputText1: string = ''; // Variable para almacenar el valor del input
  handleInputChange1() {
    this.dataSource1 = this.zonasprincipales.filter((element: any) => {
      return element.NOMBRE.toUpperCase().includes(this.inputText1.toUpperCase());
    });
    this.dataSource1.sort((a: any, b: any) => b.CHECK - a.CHECK);
  }
  async update1(completed: boolean, index: number, item: any) {
    this.zonasprincipales.forEach(item => item.CHECK = 0);
    let obj = await this.dataSource1.find((element: any) => element.idcorregimiento == item.idcorregimiento) || { CHECK: 0 };
    obj.CHECK = completed ? 1 : 0;
  }

  inputText2: string = ''; // Variable para almacenar el valor del input
  handleInputChange2() {
    this.dataSource2 = this.zonasalternas.filter((element: any) => {
      return element.NOMBRE.toUpperCase().includes(this.inputText2.toUpperCase());
    });
    this.dataSource2.sort((a: any, b: any) => b.CHECK - a.CHECK);
  }
  async update2(completed: boolean, index: number, item: any) {
    let obj = await this.dataSource2.find((element: any) => element.idcorregimiento == item.idcorregimiento) || { CHECK: 0 };
    obj.CHECK = completed ? 1 : 0;
  }

  getLista() {
    // console.log('aaaa')
    this.gateway.get('campanasagente', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.table = aux.rows;

      // console.log('table');
      // console.log(this.data.agente.idagente);
      // console.log(this.table);

      this.table.forEach(element => {
        element.campana = this.campanas.find((mini) => {
          return mini.idcampana == element.idcampana;
        })
      });
      // console.log(this.table);
      this.dataSource = new MatTableDataSource<any>(this.table);
    }
    ).catch((e) => {
      // console.log('e')
      // console.log(e)
    });
  }

  getHistorico() {

    this.gateway.get('historicoagente', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.tablelog = aux.rows;
      this.dataSourceLog = new MatTableDataSource<any>(this.tablelog);
    }
    ).catch((e) => { });

    this.gateway.get('historicoagenterol', { IDAGENTE: this.data.agente.idagente }).then((result) => {

      let aux: any = result;
      this.tablelogrol = aux.rows;
      this.dataSourceLogRol = new MatTableDataSource<any>(this.tablelogrol);
    }
    ).catch((e) => { });
  }

  getCampanas() {
    // Para usuarios sin area fija (rol dinamico o rol 27) usamos el "Tipo de servicio"
    // elegido en la pestana Datos como IDDISTRIBUIDOR para que las campanas listadas
    // correspondan al area (Inst=41 / Rep=44).
    // Para distribuidor clasico (idrol=1) seguimos usando user.IDU.
    const usuarioPGV = this.localSave.get('usuarioPGV') || {};
    const usaTipoServicio = this.tipoServicioVisible();
    const tipoServ = usaTipoServicio ? this.grupoVal.controls.TIPO_SERVICIO.value : null;
    const iddistribuidor = (usaTipoServicio && tipoServ) ? tipoServ : usuarioPGV.IDU;
    this.gateway.get('listacampanas', {
      IDDISTRIBUIDOR: iddistribuidor,
      NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais
    }).then((result) => {
      let aux: any = result;
      this.campanas = aux.rows;
      this.getLista();
    }).catch((e) => {
    });
  }

  /**
   * Llamar cuando el usuario cambia el selector "Tipo de servicio" para refrescar
   * la lista de campanas filtrada por la nueva area.
   */
  onTipoServicioChange() {
    this.campanas = [];
    this.grupoVal2.controls.CAMPANA.setValue('');
    this.getCampanas();
  }

  setkpis(element) {
    // console.log(element.value)
    this.grupoVal2.controls.CONTACTO.setValue(element.value.contacto);
    this.grupoVal2.controls.EFECTIVIDAD.setValue(element.value.efectividad);
    this.grupoVal2.controls.CONVERSION.setValue(element.value.conversion);
    this.grupoVal2.controls.TMO.setValue(element.value.tmo);
    this.grupoVal2.controls.LLAMADAS.setValue(element.value.llamadas);
    this.grupoVal2.controls.LLAMADASCEP.setValue(element.value.llamadascep);

  }

  addCampana() {
    let campana = {
      campana: this.grupoVal2.controls.CAMPANA.value,
      registros: 0,
      contacto: this.grupoVal2.controls.CONTACTO.value,
      efectividad: this.grupoVal2.controls.EFECTIVIDAD.value,
      conversion: this.grupoVal2.controls.CONVERSION.value,
      tmo: this.grupoVal2.controls.TMO.value,
      llamadas: this.grupoVal2.controls.LLAMADAS.value,
      llamadascep: this.grupoVal2.controls.LLAMADASCEP.value,
    }
    // console.log(this.table.find(element => { return element.CAMPANA.IDCAMPANA == campana.CAMPANA.IDCAMPANA }))

    if (this.table.find(element => { return element.campana.idcampana == campana.campana.idcampana })) {
      this.snackbar.open('Ya tiene asignada la campaña', '', {
        duration: 3000,
      });
      return;
    } else {

      //console.log(this.table.length)
      if (this.table.length > 0) {
        //console.log('mayor')
        this.spinner.show();
        //console.log({CAMPANAS:this.table,NUEVA:campana})
        this.gateway.save('validatraslapecampana', { CAMPANAS: this.table, NUEVA: campana }).then((result: any) => {
          // console.log(result)
          // if (result.validacion == 0) {

          this.spinner.hide();
          this.table.push(campana);
          this.dataSource = new MatTableDataSource<any>(this.table);
          // } else {
          //   this.spinner.hide();
          //   this.snackbar.open('No puedes agregar esta campaña debido a traslape de horario con otras campañas.', 'Cerrar', {
          //     duration: 5000,
          //   });
          // }

        })
      } else {
        //console.log('vacio')
        this.table.push(campana);
        this.dataSource = new MatTableDataSource<any>(this.table);
      }
    }

  }

  onNoClick() {
    for (const controlName in this.grupoVal.controls) {
      const control = this.grupoVal.get(controlName);
      // console.log(`El control '${controlName}' es inválido. Errores:`, control.errors);
      if (control && control.invalid) {
      }
    }
    this.dialogRef.close(false);
  }

  delete(element) {
    //console.log(element);
    let auxind = -1;
    // this.table.forEach((item, index) => {
    //   //console.log(item.idcampana === element.idcampana)
    //   if (item.idcampana === element.idcampana) auxind = index; //this.table.splice(index, 1);
    // });
    auxind = this.table.indexOf(element);
    this.table.splice(auxind, 1)
    this.dataSource = new MatTableDataSource(this.table);
  }

  getRoles() {
    // this.gateway.get('listaroles', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais }).then((result) => {
    //   // console.log(result);
    //   let aux: any = result;
    //   this.roles = aux.rows;
    // }
    // ).catch((e) => {
    // });
    this.roles = [
      { idrol: 17, nombre: 'AGENTE' },
      { idrol: 20, nombre: 'TECNICO' },
      // { idrol: 21, nombre: 'GESTOR DE EQUIPOS' },
      { idrol: 22, nombre: 'AGENTE DE TIENDA' }
    ];
  }

  /**
   * Carga la lista de roles que se ofrecen como Tipo Permisos
   * (campo idrol_permiso del agente). Solo los roles con es_rol_agente=1.
   */
  getRolesAgente() {
    this.gateway.get('getrolesagente', {}).then((result: any) => {
      this.rolesAgente = (result && result.rows) ? result.rows : [];
    }).catch(() => { this.rolesAgente = []; });
  }

  /**
   * Helper: muestra un snackbar con mensaje de error util y oculta el spinner.
   * Extrae el mensaje mas descriptivo posible del payload del error
   * (HTTP error, error de SQL del backend, error de gateway, etc.)
   */
  private _showSaveError(e: any): void {
    this.spinner.hide();
    let msg = 'Ocurrió un error al guardar el agente. Verifica los datos e intenta de nuevo.';
    if (e) {
      if (e.sqlMessage) {
        msg = 'Error de base de datos: ' + e.sqlMessage;
      } else if (e.error && e.error.sqlMessage) {
        msg = 'Error de base de datos: ' + e.error.sqlMessage;
      } else if (e.error && e.error.message) {
        msg = e.error.message;
      } else if (e.message) {
        msg = e.message;
      } else if (typeof e === 'string') {
        msg = e;
      }
    }
    this.snackbar.open(msg, 'Cerrar', { duration: 8000 });
    console.error('[create-agente] Error al guardar:', e);
  }

  /**
   * Persiste el idrol_permiso del agente. Se llama despues de guardar el SP
   * de crear/modificar agente. Solo aplica si el rol del agente es AGENTE (17).
   * Si no, manda null para limpiar.
   */
  private guardarIdrolPermiso(): Promise<any> {
    if (!this.idagente) return Promise.resolve();
    var idrol = Number(this.grupoVal.controls.ROL.value);
    var idrolPerm = idrol === 17 ? this.grupoVal.controls.TIPOPERMISOS.value || null : null;
    return this.gateway.save('setidrolpermiso', {
      idagente: this.idagente,
      idrol_permiso: idrolPerm
    }).catch(() => { /* no bloquear el flow principal */ });
  }

  getAreasAgente() {
    this.gateway.get('getAreasAgente', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.areas = aux.rows;
    }
    ).catch((e) => {
    });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.contratasagente = aux.rows;
    }
    ).catch((e) => {
    });
  }

  opcionRolSeleccionada(event: any): void {
    if (event.value == 20) {
      this.grupoVal.controls.TIPO_TECNICO.setValidators([Validators.required]);
      this.grupoVal.controls.TIPO_TECNICO.updateValueAndValidity();

      if (this.grupoVal.controls.TIPO_TECNICO.value == 1) {
        this.grupoVal.controls.NOMBRE_CONTRATA.setValidators([Validators.required]);
        this.grupoVal.controls.NOMBRE_CONTRATA.updateValueAndValidity();
      }

      // this.grupoVal.controls.CAPMAXAM.setValue(0);
      this.grupoVal.controls.CAPMAXAM.setValidators([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')]);
      this.grupoVal.controls.CAPMAXAM.updateValueAndValidity();
      // this.grupoVal.controls.CAPMAXPM.setValue(0);
      this.grupoVal.controls.CAPMAXPM.setValidators([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')]);
      this.grupoVal.controls.CAPMAXPM.updateValueAndValidity();

      this.grupoVal.controls.AREA.clearValidators();
      this.grupoVal.controls.AREA.updateValueAndValidity();
    } else {
      // this.grupoVal.controls.TIPO_TECNICO.setValue('');
      this.grupoVal.controls.TIPO_TECNICO.clearValidators();
      this.grupoVal.controls.TIPO_TECNICO.updateValueAndValidity();
      // this.grupoVal.controls.NOMBRE_CONTRATA.setValue('');
      this.grupoVal.controls.NOMBRE_CONTRATA.clearValidators();
      this.grupoVal.controls.NOMBRE_CONTRATA.updateValueAndValidity();
      // this.grupoVal.controls.CAPMAXAM.setValue('');
      this.grupoVal.controls.CAPMAXAM.clearValidators();
      this.grupoVal.controls.CAPMAXAM.updateValueAndValidity();
      // this.grupoVal.controls.CAPMAXPM.setValue('');
      this.grupoVal.controls.CAPMAXPM.clearValidators();
      this.grupoVal.controls.CAPMAXPM.updateValueAndValidity();

      this.grupoVal.controls.AREA.setValidators([Validators.required]);
      this.grupoVal.controls.AREA.updateValueAndValidity();
    }
  }

  opcionTipoTecnicoSeleccionada(event: any): void {
    if (event.value == 1) {
      this.grupoVal.controls.NOMBRE_CONTRATA.setValidators([Validators.required]);
      this.grupoVal.controls.NOMBRE_CONTRATA.updateValueAndValidity();
    } else {
      this.grupoVal.controls.NOMBRE_CONTRATA.setValue('');
      this.grupoVal.controls.NOMBRE_CONTRATA.clearValidators();
      this.grupoVal.controls.NOMBRE_CONTRATA.updateValueAndValidity();
    }
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.provincias = aux.rows;
    }
    ).catch((e) => {
    });
  }

  getDistritos(event: any) {
    let element = event.value;
    if (element) {
      // this.grupoVal1.controls.distrito.setValue('');
      // this.grupoVal1.controls.corregimiento.setValue('');
      this.gateway.get('getdistritosxprovincia', { id_padre: element.idprovincia }).then((result) => {
        // console.log(result);
        let aux: any = result;
        this.distritos = aux.rows;
      }
      ).catch((e) => {
      });
    }
  }

  getCorregimientos(event: any) {
    let element = event.value;
    if (element) {
      // this.grupoVal1.controls.corregimiento.setValue('');
      this.gateway.get('getcorregimientosxdistrito', { id_padre: element.id }).then((result) => {
        // console.log(result);
        let aux: any = result;
        this.corregimientos = aux.rows;
      }
      ).catch((e) => {
      });
    }
  }

  getProvinciasxAgente(idagente) {
    return new Promise((resolve, reject) => {
      this.gateway.get('getprovinciasxagente', { IDAGENTE: idagente }).then((result) => {
        let aux: any = result;
        this.provinciasxagente = aux.provinciasxagente;
        resolve(this.provinciasxagente);
      }).catch((e) => {
      });
    });

  }

  async obtenerCitasZonasEliminadas(unionzonas) {
    return new Promise((resolve, reject) => {
      return resolve({ valid: 1, auxresult: [] });
      // this.gateway.get('obtenerCantCitasxZonasEliminadas', { ZONAS: unionzonas, IDTECNICO: this.idagente }).then((result) => {
      //   console.log(result)
      //   const aux: any = result;
      //   const auxresult = aux.rows;
      //   // resolve({ valid: 1, auxresult });
      //   if (auxresult.length) {

      //     const zona = auxresult[0];
      //     this.snackbar.open(`La Zona ${zona.esprincipal == 1 ? 'Principal':'Alterna'} "${zona.nombre_corregimiento}" no puede eliminarse porque tiene ${zona.total_citas} ${zona.total_citas === 1 ? 'cita registrada' : 'citas registradas'}. `, 'Cerrar', { duration: 10000, });
      //     resolve({ valid: 0, auxresult });

      //     /*
      //     const dialogRef = this.dialog.open(ConfirmacionComponent, {
      //       disableClose: true,
      //       width: '450px',
      //       data: {
      //         sms: ` cambiar las zonas del técnico`, sms2: auxresult.length > 1 ?
      //           `Se reasignarán ${auxresult.length} citas.`
      //           : `Se reasignará ${auxresult.length} cita.`, addcomment: false
      //       }
      //     });

      //     dialogRef.afterClosed().subscribe((result) => {
      //       if (result.resp) {
      //         resolve({ valid: 1, auxresult });
      //       } else {
      //         resolve({ valid: 0, auxresult });
      //       }
      //     });
      //     */
      //   } else {
      //     resolve({ valid: 1, auxresult });
      //   }
      // }
      // ).catch((e) => {
      //   resolve({ valid: 1, auxresult: [] });
      // });
    });
  }

  async crear() {

    let idzonaprincipal = null;
    let zonasalternas = [];
    let unionzonas = [];
    let citas = [];
    if (this.grupoVal.controls.ROL.value == 20) {
      // anteriores selecciones, antes de editarlo
      const seleccionadasP = this.zonasprincipales.filter((item: any) => item.CHECK == 1);
      const seleccionadasA = this.zonasalternas.filter((item: any) => item.CHECK == 1);

      if (seleccionadasP.length != 1) { return this.snackbar.open('Debe seleccionar una zona principal.', 'Cerrar', { duration: 3000, }); }

      if (this.listaHorarios.length == 0) { return this.snackbar.open('Para continuar, ingrese los horarios de atención del técnico en la pestaña "Horarios".', 'Cerrar', { duration: 7000, }); }

      idzonaprincipal = seleccionadasP[0].idcorregimiento;
      zonasalternas = seleccionadasA;
      unionzonas = [...seleccionadasP, ...seleccionadasA];
      const resp: any = await this.obtenerCitasZonasEliminadas(unionzonas);
      citas = resp.auxresult;
      // if (!resp.valid) {
      if (citas.length) {
        return;
      }
      else {
        // return alert('siguio la edicion')
      }
    }

    let md5 = new Md5();
    let agente = {
      HORARIOS: this.listaHorarios,
      CITAS_A_REASIGNAR: citas,
      IDZONAPRINCIPAL: idzonaprincipal,
      ZONASALTERNAS: zonasalternas,
      NOMBRE: this.grupoVal.controls.NOMBRE.value,
      APELLIDO: this.grupoVal.controls.APELLIDO.value,
      IDROL: this.grupoVal.controls.ROL.value,
      IDTIPOTECNICO: this.grupoVal.controls.TIPO_TECNICO.value,
      NOMBRECONTRATA: this.grupoVal.controls.NOMBRE_CONTRATA.value,
      CAPMAXAM: this.grupoVal.controls.CAPMAXAM.value,
      CAPMAXPM: this.grupoVal.controls.CAPMAXPM.value,
      FECHANACIMIENTO: this.grupoVal.controls.FECHA_NACIMIENTO.value,
      GENERO: this.grupoVal.controls.GENERO.value,
      CORREO: this.grupoVal.controls.CORREO.value,
      CORREO2: this.grupoVal.controls.CORREO.value, // this.grupoVal.controls.CORREO2.value,
      PASSWORD: md5.appendStr(this.grupoVal.controls.PASS.value).end(),
      TELEFONO: this.grupoVal.controls.TELEFONO.value,
      PROFESION: this.grupoVal.controls.PROFESION.value,
      IDPAIS: this.idpais,
      PASSAUX: md5.appendStr(this.passaux).end(),
      IDAGENTE: this.idagente,
      // Para roles dinamicos / rol 27 sin area fija:
      //   - Si es AGENTE (ROL=17) se toma del selector "Tipo de servicio" (41 / 44).
      //   - Si es TECNICO (ROL=20) se manda por defecto 44; el backend lo inserta
      //     en agente_distribuidor para 41 y 44 (mixto).
      // Para distribuidor clasico (idrol=1) mantiene user.IDU/IDAREA como antes.
      IDDISTRIBUIDOR: this.resolverIddistribuidorPayload(),
      CUENTA: this.grupoVal.controls.CUENTA.value,
      TOKEN: this.grupoVal.controls.TOKEN.value,
      URL: this.grupoVal.controls.URL.value,
      CONFIGCANAL: this.grupoVal.controls.CONFIGCANAL.value,
      PROVINCIAS: this.grupoVal.controls.PROVINCIA.value,
      IDPADRE: this.resolverIddistribuidorPayload(),
      IDAREA: (() => {
        const idd = this.resolverIddistribuidorPayload();
        if (idd === 41) { return 14; }
        if (idd === 44) { return 15; }
        return this.localSave.get('usuarioPGV').IDAREA;
      })(),
      IDAREAAGENTE: this.grupoVal.controls.AREA.value,
      SINCRONIZAR: ((this.grupoVal.controls.CUENTA.value != '' && this.grupoVal.controls.CUENTA.value != null && this.grupoVal.controls.CUENTA.value != undefined)
        && (this.grupoVal.controls.TOKEN.value != '' && this.grupoVal.controls.TOKEN.value != null && this.grupoVal.controls.TOKEN.value != undefined)
        && (this.grupoVal.controls.URL.value != '' && this.grupoVal.controls.URL.value != null && this.grupoVal.controls.URL.value != undefined)
        && (this.grupoVal.controls.CONFIGCANAL.value != '' && this.grupoVal.controls.CONFIGCANAL.value != null && this.grupoVal.controls.CONFIGCANAL.value != undefined)) ? 1 : 0,
      SUPERVISOR: this.grupoVal.controls.SUPERVISOR.value,
      TEL_SUPERVISOR: this.grupoVal.controls.TEL_SUPERVISOR.value,
      JEFE: this.grupoVal.controls.JEFE.value,
      TEL_JEFE: this.grupoVal.controls.TEL_JEFE.value,
      PILOTO: this.grupoVal.controls.PILOTO.value ? 1 : 0
    }

    if (this.data.operacion == 'Editar' && this.data.agente.pass == this.grupoVal.controls.PASS.value) {
      agente.PASSWORD = this.grupoVal.controls.PASS.value;
      agente.PASSAUX = this.grupoVal.controls.PASS.value;
    }

    if (this.operacion == 'editagente') {
      if (this.grupoVal.controls.ROL.value == this.data.agente.idrol) {
        this.spinner.show();
        this.gateway.save(this.operacion, agente).then((result) => {
          // console.log(result[0][0])
          if (this.data.operacion == 'Crear') {
            let aux2: any = result
            //console.log(aux2.rows[0].crear_agente)
            this.idagente = aux2.rows[0].crear_agente;//result[0][0]['LAST_INSERT_ID()'];
          }

          if (agente.IDROL != 17) {
            this.table = [];
          }

          let ASG = {
            IDAGENTE: this.idagente, LISTA: this.table
          }
          // console.log(ASG);
          // if (ASG.LISTA.length > 0) {
          this.gateway.save('asignarcampana', ASG).then((check) => {
            // console.log('Se asignó');
            //console.log('eeee: ',check);
            this.guardarIdrolPermiso().then(() => {
              this.spinner.hide();
              this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
              this.dialogRef.close(true);
            }).catch((e) => this._showSaveError(e));
          }).catch((e) => this._showSaveError(e));
        }).catch((e) => this._showSaveError(e));
      } else {
        this.cambiarPerfil(agente)
      }
    } else {

      this.spinner.show();
      this.gateway.save(this.operacion, agente).then((result) => {
        // console.log(result[0][0])
        if (this.data.operacion == 'Crear') {
          let aux2: any = result
          //console.log(aux2.rows[0].crear_agente)
          this.idagente = aux2.rows[0].crear_agente;//result[0][0]['LAST_INSERT_ID()'];
        }

        if (agente.IDROL != 17) {
          this.table = [];
        }

        let ASG = {
          IDAGENTE: this.idagente, LISTA: this.table
        }
        // console.log(ASG);
        // if (ASG.LISTA.length > 0) {
        this.gateway.save('asignarcampana', ASG).then((check) => {
          // console.log('Se asignó');
          //console.log('eeee: ',check);
          this.spinner.hide();
          this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
          this.dialogRef.close(true);
        }).catch((e) => this._showSaveError(e));
      }).catch((e) => this._showSaveError(e));

    }
    // console.log(this.data.agente)
  }

  cambiarPerfil(agente) {
    const dialogperf = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: { operacion: 'editagentehistorico', id: { NUEVO: agente, ANTERIOR: this.data.agente }, msj: 'cambiar el perfil del agente', snackb: 'Comentario almacenado con éxito' }
    });

    dialogperf.afterClosed().subscribe((result) => {

      if (result) {
        this.spinner.show();
        this.gateway.save(this.operacion, agente).then((result) => {

          if (this.data.operacion == 'Crear') {
            let aux2: any = result

            this.idagente = aux2.rows[0].crear_agente;//result[0][0]['LAST_INSERT_ID()'];
          }

          if (agente.IDROL != 17) {
            this.table = [];
          }

          let ASG = {
            IDAGENTE: this.idagente, LISTA: this.table
          }
          this.gateway.save('asignarcampana', ASG).then((check) => {
            this.spinner.hide();
            this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
            this.dialogRef.close(true);
          }).catch((e) => this._showSaveError(e));
        }).catch((e) => this._showSaveError(e));
      }
    });
  }

  passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?["."#?!@$%^&*-])/;
  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    APELLIDO: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])),
    ROL: new FormControl('', Validators.compose([
      Validators.required
    ])),

    TIPO_TECNICO: new FormControl(''),
    NOMBRE_CONTRATA: new FormControl(''),
    CAPMAXAM: new FormControl(''),
    CAPMAXPM: new FormControl(''),

    PROVINCIA: new FormControl('', Validators.compose([
      // Validators.required
    ])),
    FECHA_NACIMIENTO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    GENERO: new FormControl('', Validators.compose([
      Validators.required
    ])),
    // CORREO: new FormControl('', Validators.compose([
    //   Validators.required
    // ])),
    CORREO: new FormControl('', Validators.compose([
      Validators.required, Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    ])),
    // CORREO2: new FormControl('', Validators.compose([
    //   Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    // ])),
    CORREO2: new FormControl(''),
    PASS: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    ])),
    TELEFONO: new FormControl('', Validators.compose([
      Validators.required, Validators.pattern('[2-9]{1}[0-9]{7}')
    ])),
    PROFESION: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])),
    AREA: new FormControl(''),
    CUENTA: new FormControl(''),
    TOKEN: new FormControl(''),
    URL: new FormControl(''),
    CONFIGCANAL: new FormControl(''),
    SUPERVISOR: new FormControl(''),
    TEL_SUPERVISOR: new FormControl(''),
    JEFE: new FormControl(''),
    TEL_JEFE: new FormControl(''),
    PILOTO: new FormControl(false),
    // Tipo Permisos (rol alterno) — solo aplica si ROL=17 (AGENTE)
    TIPOPERMISOS: new FormControl(null),
    // Tipo de servicio del agente (solo aplica para roles que no tienen area fija,
    // ej. roles dinamicos o read-only). Permite crear agente en Inst (41/14) o Rep (44/15).
    TIPO_SERVICIO: new FormControl(null)
  });

  generos: any = [
    { ID: 0, NOMBRE: 'Femenino' },
    { ID: 1, NOMBRE: 'Masculino' }
  ];

  grupoVal2 = new FormGroup({
    CAMPANA: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
    CONTACTO: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    EFECTIVIDAD: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    CONVERSION: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0), Validators.max(100)
    ])),
    TMO: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
    LLAMADAS: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
    LLAMADASCEP: new FormControl('', Validators.compose([
      Validators.required, Validators.min(0)
    ])),
  });

  onInputChange() {
    if (this.data.operacion == 'Editar'
      && this.grupoVal.controls.PASS.value != ''
      && this.data.agente.pass == this.grupoVal.controls.PASS.value) {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
    } else {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
    }
  }

  /**
   * El selector "Tipo de servicio" (Instalaciones / Reparaciones) solo aplica:
   *   - Cuando el usuario logueado no tiene area fija (roles dinamicos idrol>=28 o rol 27).
   *   - Y cuando el agente que se esta creando tiene ROL = 17 (Agente).
   *
   * Para tecnicos (ROL=20) no se muestra: el backend insertara automaticamente al
   * tecnico en agente_distribuidor para 41 y 44 (mixto). Default IDDISTRIBUIDOR=44.
   * Para distribuidores clasicos el area se hereda del usuario logueado.
   */
  tipoServicioVisible(): boolean {
    const u = this.localSave.get('usuarioPGV') || {};
    const usuarioSinAreaFija = (typeof u.idrol === 'number' && u.idrol >= 28) || u.idrol === 27;
    if (!usuarioSinAreaFija) { return false; }
    const rolAgente = this.grupoVal && this.grupoVal.controls.ROL.value;
    return rolAgente === 17 || rolAgente === '17';
  }

  /**
   * Determina el IDDISTRIBUIDOR que se mandara al backend al crear un agente.
   * Si hay TIPO_SERVICIO elegido lo respeta. Si es tecnico creado por usuario sin
   * area fija, default a 44 (Reparaciones) — el backend al detectar 41/44 inserta
   * automaticamente filas en agente_distribuidor para ambos lados.
   * Para distribuidor clasico (idrol=1) usa user.IDU como antes.
   */
  resolverIddistribuidorPayload(): number {
    const u = this.localSave.get('usuarioPGV') || {};
    const tipoServ = this.grupoVal && this.grupoVal.controls.TIPO_SERVICIO.value;
    if (this.tipoServicioVisible() && tipoServ) { return tipoServ; }
    const usuarioSinAreaFija = (typeof u.idrol === 'number' && u.idrol >= 28) || u.idrol === 27;
    const rolAgente = this.grupoVal && this.grupoVal.controls.ROL.value;
    const esTecnico = rolAgente === 20 || rolAgente === '20';
    if (usuarioSinAreaFija && esTecnico) { return 44; }
    return u.IDU;
  }
}
